import React, { useEffect, useRef, useState } from "react"
import { Provider, useDispatch, useSelector } from 'react-redux';

import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import rootReducer from '../redux/reducer/root.reducer';

import MapContainer from './components/map-container.component'

import { middlewares } from '../redux/middleware/root.middleware'

import { fetchMapData } from "../redux/action/map-data.action";
import Filters from "./components/filters.component";
import VesselsContainer from "./components/vessels-container.component";
import InspecitonsContainer from "./components/inspections-container.component";
import PageTitle from "./components/page-title.component";


export const store = createStore(
  rootReducer,
  applyMiddleware(thunk, ...middlewares)
);

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}


const App = () => {
  const dispatch = useDispatch(); // Works!

  return (
    <Provider store={store}>
      <PageTitle />
      <div className="container">
        <Filters /> {/* Pass the callback */}
        <div className="row">
          <div className='col-md-12'>
            <InspecitonsContainer />
          </div>
        </div>
        <MapContainer /> {/* Pass the filter value */}
      </div>
    </Provider>
  )
};

export default AppWrapper